import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

@Block() @Component
export class ApartmentButtonsBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	reactive: boolean = true;	// to make isFavorite reactive at least to a change to this variable

	get isPreview() {
		return this.$route.query.predbezne && this.$route.query.csh;
	}

	showForm(event: MouseEvent, formName: string) {
		console.error(formName)
		event.preventDefault();
		this.$modal.show(formName);
	}

	isFavorite(reactive: boolean) {
		return this.$cookiesService.getFavoriteProducts().includes(this.apartment.catalogNumber);
	}

	toggleFavorite(catalogNumber: string, to: boolean) {
		this.$cookiesService.setFavoriteProducts(to ? this.$cookiesService.getFavoriteProducts().concat(catalogNumber) : this.$cookiesService.getFavoriteProducts().filter(p => p != catalogNumber));
		this.reactive = !this.reactive;
	}
}

export default ApartmentButtonsBlock;
